export default {
  CreateRequest: "CreateRequest",
};
